import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { TronNetworkProvider } from '../../TronNetworkProvider.types';
import { fetchTronBalance } from '../fetchTronBalance';

export const createTronNetworkProvider = (
  networkData: NetworkData
): TronNetworkProvider => ({
  ...createBaseNetworkProvider('TRON', networkData),
  getBalance: async ({ address }) => ({
    balance: await fetchTronBalance({
      address,
      networkData,
    }),
  }),
});
